// src/utils/validation.js

export const validateUsername = (username) => {
  const usernameRegex = /^[a-z0-9_]{3,30}$/;
  if (!usernameRegex.test(username)) {
    return 'validation.username.invalid';
  }
  return null; // null indicates no error
};